<template>
  <div>
    <v-container
      fluid
      grid-list-md
      v-if="selectedPlan !== null && selectedPlan !== undefined"
    >
      <div class="row" v-if="planBalance !== null && planBalance !== undefined">
        <div class="col-12 col-md-9" style="padding-top:0">
          <material-card
            icon="info"
            :color="$vuetify.theme.themes.light.secondary"
            :title="$t('views.planbalance.plan_balance')"
          >
            <template v-slot:actions>
              <v-btn
                v-if="!showDetails"
                @click="showDetails = true"
                color="primary"
                class="mt-2 mr-4"
              >
                {{ $t("components.memberview.view_details") }}
              </v-btn>
              <v-btn
                v-else
                @click="showDetails = false"
                color="primary"
                class="mt-2 mr-4"
              >
                {{ $t("components.memberview.show_less") }}
              </v-btn>
            </template>
            <v-card-text>
              <div class="row">
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("components.claims_history.header.total_paid") }}
                  <br />
                  <span class="minfo">
                    {{ formatCurrency(planBalance.TotalPaid) }}
                  </span>
                </div>
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("views.balanceview.total_due") }}
                  <br />
                  <span class="minfo">
                    {{ formatCurrency(planBalance.TotalDue) }}
                  </span>
                </div>
                <div class="col-12 col-md-4 col-lg-3 col-xl-2">
                  {{ $t("views.balancepayments.balance") }}
                  <br />
                  <span class="minfo">
                    {{ formatCurrency(planBalance.Balance) }}
                  </span>
                </div>
              </div>
              <div class="row" v-if="showDetails">
                <div class="col-12 col-md-12 col-lg-12 col-xl-12">
                  <pbas-data-table
                    ref="table"
                    :dataProvider="provider"
                    identifier="planTerms"
                    @error="setDummyTerms"
                    :showSelect="false"
                  ></pbas-data-table>
                </div>
              </div>
            </v-card-text>
          </material-card>
          <material-card
            v-if="planOptions.HasStores && !planOptions.TrackPerEmployer"
            :title="$t('views.balanceview.branches')"
            :color="$vuetify.theme.themes.light.secondary"
            icon="account_balance_wallet"
          >
            <template v-slot:actions>
              <div style="margin-right:20px">
                <no-autocomplete-textfield
                  clearable
                  v-model="searchValue"
                  :label="$t('views.payments.search_locations')"
                  append-icon="search"
                />
              </div>
            </template>
            <v-card-text>
              <v-container fill-height fluid>
                <v-row justify="center">
                  {{ $t("views.balanceview.pager_{0}_{1}", [currentPage, totalPages]) }}
                </v-row>
                <v-pagination
                  v-model="currentPage"
                  :length="totalPages"
                  @input="next"
                  v-show="false"
                ></v-pagination>
                <v-row justify="center">
                  <v-btn
                    @click="next(currentPage - 1)"
                    text
                    :disabled="currentPage === 1"
                  >
                    <v-icon>chevron_left</v-icon>
                  </v-btn>
                  <span style="margin-top:8px">
                    {{ translate2(pagerItem, "Name") }}
                  </span>
                  <v-btn
                    @click="next(currentPage + 1)"
                    text
                    :disabled="currentPage === totalPages"
                  >
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <store-balance-table :store="pagerItem" />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </material-card>
          <material-card
            v-else
            :title="$t('views.balanceview.employers')"
            :color="$vuetify.theme.themes.light.secondary"
            icon="account_balance_wallet"
          >
            <template v-slot:actions>
              <div style="margin-right:20px">
                <no-autocomplete-textfield
                  clearable
                  v-model="searchValue"
                  :label="'Search Employers'"
                  append-icon="search"
                />
              </div>
            </template>
            <v-card-text>
              <v-container fill-height fluid>
                <v-row justify="center">
                  {{ $t("views.balanceview.pager_{0}_{1}", [currentPage, totalPages]) }}
                </v-row>
                <v-pagination
                  v-model="currentPage"
                  :length="totalPages"
                  @input="next"
                  v-show="false"
                ></v-pagination>

                <v-row justify="center">
                  <v-btn
                    @click="next(currentPage - 1)"
                    text
                    :disabled="currentPage === 1"
                  >
                    <v-icon>chevron_left</v-icon>
                  </v-btn>
                  <span style="margin-top:8px">
                    {{ translate2(pagerItem, "Name") }}
                  </span>
                  <v-btn
                    @click="next(currentPage + 1)"
                    text
                    :disabled="currentPage === totalPages"
                  >
                    <v-icon>chevron_right</v-icon>
                  </v-btn>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <employer-balance-table :employer="pagerItem" />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </material-card>
        </div>
        <div class="col-12 col-md-3" style="padding-top:0">
          <v-card style="margin-top:10px">
            <v-list :expand="true">
              <v-list-group no-action prepend-icon="handyman" :value="true">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("globals.edit") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item @click="notImplementedHandler">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        planOptions.HasStores && !planOptions.TrackPerEmployer
                          ? $t("views.balanceview.notify_branch")
                          : $t("views.balanceview.notify_employer")
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="notImplementedHandler">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("components.memberview.add_note") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="notImplementedHandler">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("views.balanceview.view_notes") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="notImplementedHandler">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ $t("views.balanceview.archive_note") }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="notImplementedHandler">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{
                        planOptions.HasStores && !planOptions.TrackPerEmployer
                          ? $t("views.balanceview.view_branch_contact_info")
                          : $t("views.balanceview.view_employer_contact_info")
                      }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list>
          </v-card>
        </div>
      </div>
      <error-handler :error="error"></error-handler>
    </v-container>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      v-model="notImplementedDialog"
      persistent
      max-width="400"
    >
      <v-card>
        <v-card-title>
          {{ $t("views.balanceview.not_implemented") }}
        </v-card-title>
        <v-card-actions>
          <v-btn text @click="notImplementedDialog = false">
            {{ $t("globals.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { planSetter } from "../mixins/planSetter";
import { ODataProvider, SortDirection } from "pbas-vue-components";
import ContributionsControlEmployersHeaders from "../headers/ContributionsControlEmployers";
import PlanTermsHeaders from "../headers/PlanTerms";
import ErrorHandler from "../components/ErrorHandler";
import { translate2 } from "../trans2";
import EmployerBalanceTable from "../components/BalancePayments/EmployerBalanceTable.vue";
import StoreBalanceTable from "../components/BalancePayments/StoreBalanceTable.vue";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield.vue";
export default {
  data() {
    return {
      pagerItem:null,
      notImplementedDialog: false,
      provider: undefined,
      showDetails: false,
      planBalance: null,
      error: null,
      pagerProvider: undefined,
      loading: true,
      currentPage: 0,
      itemsPerPage: 1,
      pagerFetchResult: {
        count: 0,
      },
      pagerHeaders: ContributionsControlEmployersHeaders,
      headers: PlanTermsHeaders,
      searchValue: undefined,
      searchMonitor: null,
      sortHeader: null
    };
  },
  mixins: [planSetter],
  components: {
    ErrorHandler,
    EmployerBalanceTable,
    StoreBalanceTable,
    NoAutocompleteTextfield,
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["planOptions"]),
    totalPages() {
      return Math.floor(this.pagerFetchResult.count / this.itemsPerPage);
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
    showDetails: {
      handler() {
        this.loadPlanTermsTable();
      },
    },
    searchValue: {
      async handler(v) {
        if (v === null) {
          this.searchValue = undefined;
        }
        if (this.pagerProvider === null || this.pagerProvider === undefined) {
          return;
        }
        const obj = {};
        this.searchMonitor = obj;
        await this.delay(800);
        if (this.searchMonitor !== obj) {
          return;
        }
        this.currentPage = 1;
        this.getPagerItemsAsync();
      },
    },
  },
  methods: {
    ...mapActions("plansMembers", ["getPlanBalance"]),
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    setDummyTerms() {
      this.$refs.table.pagerFetchResult = {
        items: [
          {
            Id: "78f90027-7bde-4ca3-aa9e-ae226d74864b",
            Translations: [
              {
                LanguageCode: "en",
                Name: "english name",
              },
              {
                LanguageCode: "fr",
                Name: "french name",
              },
            ],
            Name: "english name",
            StartDate: "2021-10-01T00:00:00.000Z",
            EndDate: "2021-11-01T00:00:00.000Z",
            Paid: 123.45,
            Due: 234.56,
            Balance: 111.11,
          },
        ],
        count: 1,
      };
      this.$refs.table.loading = false;
    },
    loadPlanTermsTable() {
      this.provider = new ODataProvider(
        this.$axiosHttp,
        `plans/${this.selectedPlan.Id}/terms`,
        this.headers
      );
    },
    notImplementedHandler() {
      this.notImplementedDialog = true;
    },
    formatCurrency(v) {
      let a = parseFloat(v);
      if (isNaN(a)) return "";
      var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
      });
      return formatter.format(v);
    },
    translate2(item, property) {
      return translate2(item, property);
    },
    async loadPlanData() {
      try {
        this.loading = true;

        this.planBalance = {
          TotalPaid: 1234.56,
          TotalDue: 2345.67,
          Balance: 1111.11,
        };
        // (await this.getPlanBalance({
        //   planIdentityId: this.selectedPlan.Id
        // })).data;
        // console.log("planBalance: ", this.planBalance);
        if (this.planOptions.HasStores && !this.planOptions.TrackPerEmployer) {
          this.pagerProvider = new ODataProvider(
            this.$axiosHttp,
            `plans/${this.selectedPlan.Id}/contributions-control/stores`,
            this.pagerHeaders
          );
        } else {
          this.pagerProvider = new ODataProvider(
            this.$axiosHttp,
            `plans/${this.selectedPlan.Id}/contributions-control/employers`,
            this.pagerHeaders
          );
        }
        this.sortHeader = this.pagerHeaders.filter(o=>o.title === "globals.name")[0];
        this.currentPage = 1;
        this.getPagerItemsAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    next(page) {
      this.currentPage = page;
      this.getPagerItemsAsync();
    },
    async getPagerItemsAsync() {
      if (this.pagerProvider === undefined || this.pagerProvider === null) {
        return;
      }
      this.loading = true;
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const count = this.itemsPerPage;

      try {
        this.fetchingPromise = this.pagerProvider.fetchAsync(start, count,  [{header: this.sortHeader, direction:SortDirection.Ascending}],);
        const localPromise = this.fetchingPromise;

        const result = await localPromise;
        if (localPromise === this.fetchingPromise) {
          this.pagerFetchResult = result;
          this.pagerItem = this.pagerFetchResult.items[0];
        }
        console.log(this.pagerFetchResult);
      } catch (error) {
        this.pagerFetchResult = {
          count: 2,
          items: [
            {
              Translations: [
                {
                  LanguageCode: "en",
                  Name: "Branch 1",
                },
                {
                  LanguageCode: "fr",
                  Name: "Branch 1 fr",
                },
              ],
              Id: "4828046b-1c05-4a51-b603-593e4ac3c000",
              Name: "Branch 1",
            },
            {
              Translations: [
                {
                  LanguageCode: "en",
                  Name: "Branch 2",
                },
                {
                  LanguageCode: "fr",
                  Name: "Branch 2 fr",
                },
              ],
              Id: "4828046b-1c05-4a51-b603-593e4ac3c001",
              Name: "Branch 2",
            },
          ],
        };
        this.pagerItem = this.pagerFetchResult.items[0];
        // this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.minfo {
  font-weight: bold;
  color: #222;
}
.member-view /deep/ .v-list-group__items > .v-list-item {
  padding-left: 45px;
}
.text-white {
  color: white;
}
</style>
